import type { PropsWithChildren } from 'react'
import React, { useState } from 'react'

import styles from './ZoomImage.module.scss'
import clsx from 'clsx'
interface ZoomImageProps extends PropsWithChildren {
  src: string
}
const ZoomImage: React.FC<ZoomImageProps> = ({ children, src }) => {
  const [transform, setTransform] = useState<{ x: number; y: number }>({ x: 0, y: 0 })
  const [zoomed, setZoomed] = useState(false)
  const nextImgSrc = `/_next/image?url=${src}&w=3840&q=100`
  const handleMouseMove = (e: React.MouseEvent<HTMLDivElement>) => {
    const rect = e.currentTarget.getBoundingClientRect()
    const x = e.clientX - rect.left
    const y = e.clientY - rect.top

    const xPercent = (x * 100) / rect.width
    const yPercent = (y * 100) / rect.height

    const extraX = x < rect.width / 2 ? -2 : 2
    const extraY = y < rect.height / 2 ? -2 : 2

    setTransform({ x: xPercent + extraX, y: yPercent + extraY })
    setZoomed(true)
  }

  const handleMouseLeave = () => {
    setTransform({ x: 0, y: 0 })
    setZoomed(false)
  }

  return (
    <div
      className={clsx(styles.wrapper, zoomed && styles.box_shadow)}
      onMouseMove={handleMouseMove}
      onMouseLeave={handleMouseLeave}
    >
      <div className={clsx(styles.imageContainer, zoomed && 'hover:cursor-zoom-in')}>
        {!zoomed && children}
        <div
          className={clsx('w-full h-full', { invisible: !zoomed })}
          style={{
            backgroundSize: '125%',
            backgroundRepeat: 'no-repeat',
            backgroundImage: `url(${nextImgSrc})`,
            backgroundPosition: `${transform.x}% ${transform.y}%`,
          }}
        ></div>
      </div>
    </div>
  )
}

export default ZoomImage
